import { persistUtmParamsFromUrl } from "../../utils/utm"

if (!window.App) {
  window.App = {}
}

App.$ = $ // Allows us to use App.$ in UJS partials to get the Cash wrapper.

App.refireLoad = () => document.dispatchEvent(new Event("turbolinks:load", { bubbles: true, cancelable: true }))

// Global error handler to catch unhandled errors, especially Safari/iOS autofill errors
if (typeof window !== "undefined") {
  persistUtmParamsFromUrl()

  // Safari/iOS autofill may call this global; define a no-op so ReferenceError never fires
  if (typeof window._AutofillCallbackHandler === "undefined") {
    window._AutofillCallbackHandler = function () {}
  }

  window.addEventListener("error", (event) => {
    const msg = event.message || ""

    if (msg.includes("_AutofillCallbackHandler") || msg.includes("Can't find variable: _AutofillCallbackHandler")) {
      event.preventDefault()
      return false
    }

    if (msg.includes("lastSetTimerId")) {
      event.preventDefault()
      return false
    }

    if (msg.includes("ResizeObserver loop")) {
      event.preventDefault()
      return false
    }

    if (msg === "The operation is insecure.") {
      event.preventDefault()
      return false
    }

    if (event.error && !msg.includes("_AutofillCallbackHandler")) {
      console.error("Unhandled error:", event.error)
    }
  })

  window.addEventListener("unhandledrejection", (event) => {
    const reasonMsg = event.reason?.message ?? String(event.reason)

    if (reasonMsg.includes("_AutofillCallbackHandler") || String(event.reason).includes("_AutofillCallbackHandler")) {
      event.preventDefault()
      return false
    }

    if (reasonMsg.includes("lastSetTimerId")) {
      event.preventDefault()
      return false
    }

    console.error("Unhandled promise rejection:", event.reason)
  })
}
